export type Language = 'da' | 'de' | 'en' | 'fi' | 'fr' | 'nl' | 'sv'

export function isLanguage(value?: string): value is Language {
  const validLanguages = ['da', 'de', 'en', 'fi', 'fr', 'nl', 'sv'] as const satisfies readonly Language[]
  return validLanguages.includes(value as Language)
}
